export const HISTORY_OF_CHANGES = '/api/v1/history';
